import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/home/home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/unlink',
    name: 'unlink',
    component: () =>
      import('../views/unlink/unlink.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
